import LocalStorage from '../../../services/LocalStorage';

const Local = new LocalStorage();

const state = {
    email: Local.get('customer.email'),
    hooks: {
        emailCaptured: [],
    },
    hooksData: {
        emailCaptured: {
            email: null,
        },
    },
};

const getters = {
    getHookData: state => hook => {
        return state.hooksData[hook];
    },

    email: state => {
        return state.email;
    },
};

const actions = {
    addHook({ state }, { hook, name, callback }) {
        if (typeof state.hooks[hook] == 'undefined') {
            return console.error(
                `Cannot add hook. "${hook}" hook is not valid hook in the "Customer" store. Please see documentation for all available hooks.`,
                'https://docs.hlx.dev/lego/hooks'
            );
        }

        state.hooks[hook].push({ name: name, callback: callback });
    },

    async saveEmail({ commit }, email) {
        state.hooksData.emailCaptured.email = email;

        for (const hook of state.hooks.emailCaptured) {
            await hook();
        }

        commit('SAVE_EMAIL', email);
    },
};

const mutations = {
    SAVE_EMAIL(state, email) {
        state.email = email;

        Local.save('customer.email', email);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
